import React from "react";
import {
  Image,
  ImageBackground,
  Modal,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import globalstyle from "../../Styles/Globals/globals";
import style from "./style";
import { getRecursText, getRecursURL } from "../../Functions/getRecurs";

function PopUpQuizzLabel(
  RouterData,
  pista,
  setPista,
  infoPista,
  numPista,
  setNumPista,
) {
  const { recursos, idioma, itinerari, poi } = RouterData.route.params;

  if (!infoPista) {
    infoPista = {
      id: 3,
      valid:
        getRecursText(recursos, "text_resposta_correcta", idioma) +
        " " +
        itinerari.pois.find((e) => e.id == poi.id)["Quizz" + idioma]
          .respostes[0].valid,
    };
  }
  return (
    <Modal animationType="fade" transparent={true} visible={pista}>
      <View style={style.modalOutBackground}>
        <View style={[style.caixaPopUp, { height: "50%" }]}>
          <ImageBackground
            source={{
              uri: getRecursURL(recursos, "background_default", idioma),
            }}
            style={style.backgroundImatges}
          >
            {/* Close button */}
            <TouchableOpacity
              style={globalstyle.crossBox}
              onPress={() => {
                setPista(false);
                setNumPista(numPista + 1);
              }}
            >
              <Image
                source={{
                  uri: getRecursURL(recursos, "pop_up_close_icon", idioma),
                }}
                style={style.cross}
              />
            </TouchableOpacity>
            <View
              style={{
                flex: 30,
                justifyContent: "center",
                alignItems: "center",
                alignSelf: "center",
              }}
            >
              <Text style={style.popUpTitleInicial}>
                {getRecursText(recursos, "text_pista", idioma)} {infoPista?.id}
              </Text>
            </View>
            <View
              style={{
                flex: 50,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Text style={style.popUpMapaText}> {infoPista.valid} </Text>
            </View>
            <View
              style={{
                flex: 20,
                justifyContent: "center",
                alignItems: "center",
                alignSelf: "center",
              }}
            >
              <TouchableOpacity
                onPress={() => {
                  setPista(false);
                  setNumPista(numPista + 1);
                }}
              >
                <Text style={globalstyle.botoContinuar}>
                  {getRecursText(recursos, "text_continuar", idioma)}
                </Text>
              </TouchableOpacity>
            </View>
          </ImageBackground>
        </View>
      </View>
    </Modal>
  );
}

export default PopUpQuizzLabel;
